import { downloadBase64 } from '../utils/downloadFiles';

import { api } from './apiInstances';
// to get information for Header and Table

export const postReporteNotificacion = async (body) => {
  const result = await api.post(`/v1/Reportes/reporteNotificacion`, body);

  return result.data;
};

export const postExcelDetail = async (body) => {
  const result = await api.post(`/v1/Reportes/reporteNotificacionExcel`, body);

  downloadBase64(result.data, 'Reporte', 'xlsx');
};
